import { createSelector } from "reselect";
const selectQuotationState = createSelector((state) => state.quotation, state => state);
const selectQuotation = createSelector(selectQuotationState, state => state.quotation);
export { selectQuotation };
